// Module
var code = `<div data-bind="style: {height: fullHeight ? '100%' : '1em'}">
    <span class="bar" data-bind="style: {width: percentStr}"></span>
    <span class="label" data-bind="text: percentStr, css: {gt50: percent() > 50}"></span>
</div>
`;
// Exports
export default code;